<template>
    <div>
        <v-dialog v-model="deleteConfirmDialog" persistent max-width="290">
            <v-card>
                <v-card-text>Are you sure you want to delete this {{deleteName}} ?</v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn class="elc-button-radius" flat @click.native="$emit('close')">Cancel</v-btn>
                    <v-btn class="elc-button-radius-color" flat @click.native="$emit('delete')">OK
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
    export default {
        name: 'DeleteConfirmDialog',
        components: {},
        props: ['deleteName', 'deleteConfirmDialog'],
        created() {
        },
        data() {
            return {}
        },
        methods: {}
    }
</script>


// WEBPACK FOOTER //
// src/components/Common/DeleteConfirmDialog.vue